import { createContext } from 'react';
export var WaitContext = /*#__PURE__*/createContext({
  subscribe: function subscribe() {
    return function () {};
  },
  currentValue: function currentValue() {
    return 1;
  }
});